export const convertDateCustomToDate = (dateCustom) => (dateCustom ? new Date(
  dateCustom.year,
  dateCustom.month,
  dateCustom.day,
) : null);

export const convertTimeCustomToTime = (timeCustom) => (timeCustom ? new Date(
  0,
  0,
  0,
  timeCustom.hours,
  timeCustom.minutes,
) : null);

export const getSysLocale = () => navigator.language.split(/[-_]/)[0]; // language without region code.
